"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 41.14 24",
    width: "41.14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m1.37 15.2h38.4a.69.69 0 0 0 .69-.69v-13.82a.69.69 0 0 0 -.69-.69h-38.4a.68.68 0 0 0 -.68.69v13.82a.68.68 0 0 0 .68.69zm.88-13.64h36.64v12.06h-36.64z",
    fill: "#93c01f"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m40.36 16.7h-39.58a.78.78 0 0 0 0 1.56h4v4.89a.79.79 0 1 0 1.57 0v-4.89h29.89v4.89a.78.78 0 1 0 1.56 0v-4.89h2.56a.78.78 0 0 0 0-1.56z",
    fill: "#93c01f"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m18.18 13.07v-10.96l9.12 5.48z",
    fill: "#9ece06"
  }));
};

exports["default"] = _default;